/** Format Date for datetime-local input (YYYY-MM-DDTHH:mm). */
export const toDatetimeLocalValue = (date = new Date()) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/** Convert datetime-local value to ISO string for API. */
export const datetimeLocalToIso = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

/** Browser datetime for Excel rows missing recorded_at. */
export const browserDatetimeIso = () => new Date().toISOString();
